import {createSelector} from 'reselect'

export const getLoading = createSelector(
  state => Boolean(state && state.vehicleParts && state.vehicleParts.list && state.vehicleParts.list.isLoading),
  isLoading => isLoading
)
